import { GradedUnit } from './graded-unit.model';

export class GradedUnitUpdateCommand {
    name: string;
    weight: number;
    sequence: number;

    constructor(gradedUnit: GradedUnit) {
        // Graded units with course offering are Final Course Grades, we can not update name for them
        if (!gradedUnit.courseOffering) {
            this.name = gradedUnit.name;
        }
        this.weight = gradedUnit.gradeWeight;
        this.sequence = gradedUnit.sequence;
    }
}
